import { c as _c } from "react/compiler-runtime";
import { skipToken, useQuery } from '@tanstack/react-query';
import { useWeb3Context } from '@/contexts/Web3Context';
import { orpc } from '@/lib/orpc/client';
import { USER_MARKET_POSITIONS_STALE_TIME, userMarketPositionKey } from '../config/config';

/**
 * The markets the connected wallet holds collateral in, read from the server-prefetched
 * `user.marketPositions` query and refetched when the wallet changes.
 *
 * @returns A Set of composite keys (`chainId:marketId`) identifying markets with active positions.
 */
export function useUserMarketPositions() {
  const $ = _c(6);
  const {
    account
  } = useWeb3Context();
  let t0;
  if ($[0] !== account.address) {
    t0 = orpc.user.marketPositions.queryOptions({
      input: account.address ? {
        userAddress: account.address
      } : skipToken,
      staleTime: USER_MARKET_POSITIONS_STALE_TIME
    });
    $[0] = account.address;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data
  } = useQuery(t0);
  let keys;
  let t1;
  if ($[2] !== account.address || $[3] !== data) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      keys = new Set();
      if (!account.address || !data) {
        t1 = keys;
        break bb0;
      }
      for (const {
        chainId,
        marketId
      } of data.items) {
        keys.add(userMarketPositionKey(chainId, marketId));
      }
    }
    $[2] = account.address;
    $[3] = data;
    $[4] = keys;
    $[5] = t1;
  } else {
    keys = $[4];
    t1 = $[5];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  return keys;
}